<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :isEditing="true"
            @save-item="updateItem"
            @create-vast-profiel="createVastProfiel"
            @create-adaptief-profiel="createAdaptiefProfiel"
            @open-form-import="openFormImport">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: DLI profiel werd niet gewijzigd! {{errormsg}}
        </b-modal>

        <b-modal title="DLI profiel creëren" size="sm" class="modal-primary" v-model="warningGeduld">
            <div slot="modal-footer" class="w-100"><p>Even geduld a.u.b.</p></div>
            <p><fadeloader :loading="loading" :size="size" :color="color" class="spinner"></fadeloader></p>
            <p>&nbsp;<br/>&nbsp;</p>
            <p>DLI profiel wordt gecreëerd. Deze bewerking kan even duren.</p>
        </b-modal>

        <b-modal title="Vast DLI profiel creëren" size="sm" class="modal-primary" v-model="vraagBevestiging" :no-close-on-backdrop="true">
            <div slot="modal-footer" class="w-100">
                <p>
                    <b-button @click="closeFormVastProfiel(model)" variant="secondary">Annuleren</b-button>
                    <b-button @click="maakVastProfiel(model)" variant="primary">OK</b-button>
                </p>
            </div>
            <p><strong>Let op! Indien er al een DLI profiel bestaat, dan wordt dit overschreven!</strong></p>
        </b-modal>

        <b-modal title="Adaptief DLI profiel creëren" size="sm" class="modal-primary" v-model="vraagBewolkingsgraad" :no-close-on-backdrop="true">
            <div slot="modal-footer" class="w-100">
                <p>
                    <b-button @click="closeFormAdaptiefProfiel(model)" variant="secondary">Annuleren</b-button>
                    <b-button @click="maakAdaptiefProfiel(model)" variant="primary">OK</b-button>
                </p>
            </div>
            <p><strong>Let op! Indien er al een DLI profiel bestaat, dan wordt dit overschreven!</strong></p>
            <p>
                <div class="row">
                    <div class="col-sm-2">
                        <input type="radio" name="optradio" value="V" v-on:change="kies('V')" v-model="model.vastofgemiddeld">
                    </div>
                    <div class="col-sm-10">
                        <label class="radio-inline" style="margin-left: -20px;">Vaste bewolkingsgraad</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2" >
                    </div>
                    <div class="col-sm-10">
                        <div class="form-group">
                            <label class="col-form-label" for="bewolkingsgraad">Percentage</label>
                            <input type="number" step="1" min="0" max="100" v-model="model.bewolkingsgraad" id="bewolkingsgraad" name="bewolkingsgraad" v-validate="'min_value:0|max_value:100'" :class="{'form-control': true, 'is-invalid': errors.has('bewolkingsgraad') }" />
                            <span class="small text-danger" v-show="foutbewolkingsgraad">Bewolkingsgraad is een waarde tussen 0 en 100</span>
                        </div>
                    </div>
                </div>
                <div class="row"></div>
                <div class="row">
                    <div class="col-sm-2">
                        <input type="radio" name="optradio" value="G" v-on:change="kies('G')" v-model="model.vastofgemiddeld">
                    </div>
                    <div class="col-sm-10">
                        <label class="radio-inline" style="margin-left: -20px;">Gemiddelde bewolkingsgraad</label>
                    </div>
                </div>
            </p>
        </b-modal>

        <b-modal title="DLI profiel importeren" size="lg" class="modal-primary" v-model="vraagBestand" :no-close-on-backdrop="true">
            <div slot="modal-footer" class="w-100">
                <p>
                    <b-button @click="closeFormImport(model)" variant="secondary">Annuleren</b-button>
                    <b-button @click="doImport(model)" variant="primary">OK</b-button>
                </p>
            </div>
            <p><strong>Let op! Bestaand DLI profiel wordt overschreven!</strong></p>

            <p>
            <div class="form-group">
                <label class="col-form-label" for="fileToUpload">Csv-bestand</label>
                <b-form-file accept=".csv" ref="file-input" id="fileToUpload" name="fileToUpload" v-model="model.fileToUpload" :plain="true"></b-form-file>
                <span class="small text-danger" v-show="foutbestand">Kies een csv-bestand</span>
            </div>
            </p>

        </b-modal>

        <b-modal title="DLI profiel importeren" size="sm" class="modal-primary" v-model="warningGeduldImport">
            <div slot="modal-footer" class="w-100"><p>Even geduld a.u.b.</p></div>
            <p><fadeloader :loading="loading" :size="size" :color="color" class="spinner"></fadeloader></p>
            <p>&nbsp;<br/>&nbsp;</p>
            <p>Het DLI profiel wordt geïmporteerd. Deze bewerking kan even duren.</p>
        </b-modal>

        <b-modal title="DLI profiel importeren" size="sm" class="modal-danger" v-model="errorImport" @ok="closedialog">
            FOUT: DLI profiel werd niet geïmporteerd! Controleer de structuur van het csv-bestand. {{errormsg}}
        </b-modal>

        <b-modal title="DLI profiel creëren" size="sm" class="modal-danger" v-model="warningProfiel" @ok="closedialog">
            FOUT: DLI profiel werd niet gecreëerd! {{errormsg}}
        </b-modal>
    </div>

    <div v-else class="midden">
        <div style="color: #20a8d8; font-size: large;">Even geduld a.u.b.</div>
        <fadeloader :loading="loading" :size="size" :color="color" class="spinner2"></fadeloader>
    </div>
</template>

<script>
    // https://github.com/greyby/vue-spinner
    import FadeLoader from 'vue-spinner/src/FadeLoader';
    import api from '../../api/afdelingteelt';
    import ItemForm from './FormDliprofiel.vue';

    export default {
        data () {
            return {
                warningModal: false,
                warningProfiel: false,
                warningGeduld: false,
                warningGeduldImport: false,

                vraagBestand: false,
                errorImport: false,

                foutbestand: false,

                vraagBevestiging: false,
                vraagBewolkingsgraad: false,

                foutbewolkingsgraad: false,
                errormsg: '',
                model: { },

                loading: true,
                size: '20px',
                color: '#20a8d8',
            };
        },
        created () {
            this.getProfiel(this.$route.params.id);
        },
        methods: {
            getProfiel (id) {
                api.getDliprofiel(id).then((response) => {
                    this.model = response.data.model;
                });
            },
            createVastProfiel (model) {
                this.vraagBevestiging = true;
            },
            closeFormVastProfiel (model) {
                this.vraagBevestiging = false;
            },
            maakVastProfiel (model) {
                this.warningGeduld = true;
                api.createVastDliprofiel(model).then(() => {
                    this.warningGeduld = false;
                    this.getProfiel(model.id);
                },
                (error) => {
                    this.warningGeduld = false;
                    this.errormsg = error.message;
                    this.warningProfiel = true;
                });
            },
            kies (vastofgemiddeld) {
                this.model.vastofgemiddeld = vastofgemiddeld;
            },
            createAdaptiefProfiel (model) {
                this.model.bewolkingsgraad = "50";
                this.model.vastofgemiddeld = "V"; // kan V ast of G emiddeld zijn
                this.foutbewolkingsgraad = false;
                this.vraagBewolkingsgraad = true;
            },
            closeFormAdaptiefProfiel (model) {
                this.vraagBewolkingsgraad = false;
            },
            maakAdaptiefProfiel (model, event) {
                if ((this.model.bewolkingsgraad == "") && (this.model.vastofgemiddeld == "V")) {
                    this.foutbewolkingsgraad = true;
                } else {
                    this.foutbewolkingsgraad = false;
                    this.vraagBewolkingsgraad = false;
                    this.warningGeduld = true;
                    api.createAdaptiefDliprofiel(model).then(() => {
                            this.warningGeduld = false;
                            this.getProfiel(model.id);
                        },
                        (error) => {
                            this.warningGeduld = false;
                            this.errormsg = error.message;
                            this.warningProfiel = true;
                        });
                }
            },
            updateItem (model) {
                api.updateDliprofiel(model).then(() => {
                    this.$router.replace('/beheer/afdelingteelt');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
                this.warningProfiel = false;
            },
            openFormImport (model) {
                // this.model.fileToUpload = new File([""], "filename");
                this.$refs['file-input'].reset();
                this.foutbestand = false;
                this.vraagBestand = true;
            },
            closeFormImport (model) {
                this.vraagBestand = false;
            },
            doImport (model, event) {
                if (this.model.fileToUpload == undefined) {
                    this.foutbestand = true;
                } else {
                    this.foutbestand = false;
                    this.vraagBestand = false;
                    this.warningGeduldImport = true;

                    let formData = new FormData();
                    formData.append('fileToUpload', this.model.fileToUpload);
                    formData.append('id', this.model.id);
                    api.importDLIProfiel(formData).then(() => {
                            this.warningGeduldImport = false;
                            this.getProfiel(model.id);
                        },
                        (error) => {
                            this.warningGeduldImport = false;
                            this.errormsg = error.message;
                            this.errorImport = true;
                        });
                }
            },
        },
        components: {
            'item-form': ItemForm,
            fadeloader: FadeLoader,
        },
    };
</script>

<style>

    .spinner {
        margin-top: 30px;
        margin-bottom: 20px;
        margin-left:130px;
        color: #20a8d8;
    }

    .spinner2 {
        margin-top: 30px;
        margin-left:75px;
        color: #20a8d8;
    }

    .midden {
        width: 150px;
        height: 100px;

        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        margin: auto;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/EditDliprofiel.vue